module.exports = __webpack_public_path__ + "4b8858a3fc0f83c5e3b6721f75aaa0be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-20.jpg
// module id = 1161
// module chunks = 0